var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-overlay',{attrs:{"show":_vm.isLoading}},[_c('FormSchema',{ref:"form",attrs:{"schema":_vm.schema,"mode":_vm.mode,"layout":_vm.layout,"fieldLayout":_vm.fieldLayout},on:{"submit":_vm.onSubmit}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }